jQuery(document).ready(function(){
	
	jQuery('body').addClass('loaded');
	
});


jQuery( ".mobile-toggle button" ).click(function() {
	
  jQuery( ".top-nav" ).toggleClass( 'menu-open' );
  
});

jQuery(document).ready(function(){

	var divs = jQuery('.choices span[id^="choice-"]').hide(),
	    i = 0;
	
	(function cycle() { 
	
	    divs.eq(i).fadeIn(1000)
	              .delay(3000)
	              .fadeOut(1000, cycle);
	
	    i = ++i % divs.length;
	
	})();

});


var boxHovered, boxNumber, selector, targetedBox, adjustX, adjustY;

jQuery(".popup").hide();//This hides all the pop-ups when page loads


jQuery(".box").hover( function() {//This executes when you hover ON the box
	
	boxHovered = jQuery(this).attr("id");//Gets the id of the box such as "box1", "box2"
		
	targetedBox = "#" + boxHovered;//creates a value of "#box1", "#box2", etc for future use
		
	boxNumber = boxHovered.substr(3,5);//extracts the # from the id, such as 1, 2, 3
		
	selector = "#popup"+boxNumber;//creates a value of "#popup1", "#popup2", etc for future use
		
	jQuery(selector).show();//This reveals the popup inside the hovered box
	
	moveBox();//This calls on the function below to execute
		
},function(){ //This executes when you hover OFF the box
		
	 jQuery(selector).hide();//This hides the popup inside the hovered box
		 
});
	
function moveBox(){
	
	jQuery(targetedBox).bind('mousemove',function(event){//Executes when the mouse MOVES
		
	adjustX = jQuery(this).find(".popup").outerWidth(true);//gets the width of the targeted popup
	
	adjustY = jQuery(this).find(".popup").outerHeight(true);//gets the height of the targeted popup
	
	if(targetedBox == "#box1") {//example of moving popup relative to mouse
				
		adjustX = jQuery(this).find(".popup").outerWidth(true)-12;//creates a more unique value
				
		adjustY = jQuery(this).find(".popup").outerHeight(true)-12;
				
	}
	
	//event.pageY or evet.pageX = the mouse position relative to the top left of the targeted box
	
	var my = event.pageY-jQuery(this).offset().top-adjustY;//my = mouse y position with some adjustment relateive to top of box
	
	var mx = event.pageX-jQuery(this).offset().left-adjustX; //mx = mouse x position with some adjustment relateive to left of box
	
		jQuery(selector).css({//set the selected popup box coordinates near the mouse as the mouse moves
			"left":mx,
			"top":my
		});
	});	
}

jQuery("*").each(function() {
    var cur = jQuery(this);
    if(cur.css("cursor") == "pointer") {
       jQuery(this).addClass('new-pointer');
    }
});

jQuery('a[href*="#"]:not([href="#"])').click(function() {
    var offset = -200; // <-- change the value here
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = jQuery(this.hash);
        target = target.length ? target : jQuery('[name=' + this.hash.slice(1) +']');
        if (target.length) {
            jQuery('html, body').animate({
                scrollTop: target.offset().top + offset
            }, 1000);
            return false;
        }
    }
});


jQuery('button.down').click(function(){
	
	jQuery( "html, body" ).animate({scrollTop: jQuery(document).height()}, 1000);
	
});

jQuery(document).on("gform_confirmation_loaded", function() {
  
  jQuery('.contact').find('p').hide();
  
});

jQuery('.readmore').click(function(){
	
	jQuery( ".studio-long" ).toggleClass('open');
	
	window.getSelection().empty();
	
});


jQuery('.open-links a').click(function() {
	
	var open = jQuery(this).data('open');
     	open = '#' + open + ' .accordion-title';
     	
     jQuery(open).trigger('click');
	

});

jQuery('.accordion-title').click(function() {
	
	jQuery(this).blur();
	

});